<template>
  <div 
    v-if="show" 
    class="modal" 
  >
    <div @click="closeModal" class="modal__close">
      <svg
        class="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M6 18L18 6M6 6l12 12"
        ></path>
      </svg>
    </div>
    <form class="form" @submit.prevent="pay">
      <h2 class="modal__title">Step 1 of 2</h2>
      <h3 class="modal__subtitle">Enter your email and name</h3>
      <div>
        <label for="">First name</label>
        <input
          ref="name"
          class="form__input"
          placeholder="First name"
          type="text"
          v-model="data.firstName"
          required
        />
      </div>
      <div>
        <label for="">Last name</label>
        <input
          ref="name"
          class="form__input"
          placeholder="Last name"
          type="text"
          v-model="data.lastName"
          required
        />
      </div>
      <div>
        <label for="">Email</label>
        <input
          class="form__input"
          placeholder="Your email"
          type="email"
          v-model="data.email"
          required
        />
      </div>
      <div>
        <input 
          @submit="pay" 
          class="button" 
          type="submit" 
          value="Submit" 
        />
      </div>
    </form>
  </div>
</template>

<script>
export default {
  props: {
    show: Boolean,
    type: Number,
    price: Number,
  },
  data() {
    return {
      data: {
        email: '',
        firstName: '',
        lastName: '',
      },
    }
  },
  methods: {
    closeModal() {
      this.$emit('closeModal')
    },
    pay() {
      this.$store
        .dispatch('pay', { ...this.data, type: this.type, price: this.price })
        .then((finalLink) => {
          window.open(finalLink)
          this.$store.dispatch('logUser', {
            ...this.data,
            from: this.$route.query.from,
          })
          this.$store.dispatch('sendEmail', this.data)
        })
    },
  },
}
</script>

<style lang="sass" scoped>

.modal 
  position: fixed
  top: 50%
  left: 50%
  transform: translate(-50%, -50%)
  background-color: #fff
  padding: 20px
  max-width: 300px
  width: 100%
  z-index: 100000

  &__title 
    margin-top: 0
  

  &__close 
    width: 20px
    position: absolute
    top: 10px
    right: 10px
    cursor: pointer
  

  .form 
    margin-top: 20px
    // text-align: center
    &__input 
      width: 100%
      border: 1px solid rgb(95, 95, 95)
      padding: 10px
      margin-bottom: 20px

    .modal__title
      padding-top: 1em
      padding-bottom: 1em

    .modal__subtitle
      padding-bottom: 1em


    
.modal
  color : $color-text-common2
  
  .offline
    color : $color-text-slight
    background: transparentize($color-bg-second, 0.05)
    .table
        width : 100%
        height: 100%
        >div
          vertical-align: middle
          text-align: center
          padding-bottom: 45%

          .icon
              font-size: 2.3em
              padding : $r
              color : $color-text-second2

          .label
              font-size: 1em
              padding : 0 8 * $r

  .callmenu
    position: fixed
    bottom : 4 * $r
    left : 0
    right : 0
    z-index: 2022
    text-align: center

    button.button
      margin-right : 3 * $r
      
      +transition(0.3s)

      &.round
          width : 55px
          height : 55px
          line-height: 53px

      &.cancel,
      &.callcancel
          border : 1px solid $color-bad
          color : #fff
          background: $color-bad

      &.callup
          border : 1px solid $color-text-slight
          color : $color-text-slight
          background: transparentize($color-bg-backface, 0.3) 

          &.active
              border : 1px solid $color-bg-main
              color : $color-bg-main
              animation: pulse 2s infinite

      &.callupvideo
          border : 1px solid $color-text-slight
          color : $color-text-slight
          background: transparentize($color-bg-backface, 0.3) 

          &.active
              border : 1px solid $color-bg-main
              color : $color-bg-backface
              background : $color-bg-main

      &:nth-last-child(1)
          margin-right : 0

          
  .preloaderWrapper,             
  .fixedallwrapper
    position: fixed
    left : 0
    right : 0
    top : 0
    bottom : 0
    z-index : 2900
    +transition(0.3s)



  .fixedOnPageBottom
    +transition(0.3s)
  .back
    position: fixed
    left : 3 * $r
    top : 3 * $r
    color : $color-text-slight
    z-index: 120
    +transition(0.3s)

  .preloaderWrapper,
  .fixedallwrapper
      opacity: 0

  .back
      opacity: 0
      top : -3 * $r 

  .fixedOnPageBottom
    opacity: 0
    bottom : -3 * $r 


.button
  background: $color-bg-main
  border : 1px solid $color-bg-main
  outline: none
  color : #ffffff
  padding : 2 * $r
  text-align: center
  +transition(0.3s)
  min-width: 200px
  cursor: pointer
  outline: none
  text-decoration: none

  &.small
    // padding : $r 2 * $r
    padding: 10px
    min-width: 150px

  &.good
    background: $color-good
    border : 1px solid $color-good


    &:hover
      background: transparentize($color-good, 0.1)
      color : #fff

  &.black
    background: $color-bg-light
    border : 1px solid $color-bg-light
    color : $color-text-light


    &:hover
      background: transparentize($color-bg-light, 0.1)
      color : #fff

  &.orange
    background: $color-text-orange
    border : 1px solid $color-text-orange


    &:hover
      background: transparentize($color-text-orange, 0.1)
      color : #fff

    &.round
      width: 44px
      height: 44px
      border-radius: 50%
      font-size: 0.8em
      min-width: 0
      padding : 0
      line-height: 42px

    &.border
      background: transparent
      color : $color-bg-main
      font-size: 0.8em

    &.ghost
      background: transparent
      border : 1px solid transparent
      color : $color-bg-main

      &:hover
        color : $color-text-light

    &:hover
      background: transparent
      color : $color-bg-main

    &.underscored
      text-decoration: underline

    &[disabled="disabled"]
      cursor: default
      background : $color-text-mlight
      border-color : $color-text-mlight

      &:hover
        color : #fff
        background : $color-text-mlight
        border-color : $color-text-mlight


.fade-enter,
.fade-leave-to
    opacity: 0


.fade-enter-active,
.fade-leave-active
    transition: opacity 0.2s ease

    
.modal-backdrop 
    position: fixed
    z-index: 3000
    top: 0
    bottom: 0
    left: 0
    right: 0
    background: rgba($color-text-common, 0.7)
    display: flex
    justify-content: center
    align-items: center

.modal 
  background: $color-bg-common    
  color : $color-text-common 
  overflow-x: auto
  display: flex
  flex-direction: column
  min-width: 450px
  box-shadow: 0 7px 12px -5px rgb(0 0 0 / 70%)


.modal-close
    position: absolute
    top : 0
    right : 0
    padding : 2 * $r
    color : $color-text-main
    cursor: pointer
    +transition(0.3s)

    &:hover
        color : $color-text-common

.modal-header,
.modal-footer 
    padding: 2 * $r  2 * $r
    display: flex


.modal-header 
    border-bottom: 1px solid $color-bg-light
    color: $color-text-main
    justify-content: space-between


.modal-footer 
    justify-content: flex-end

.mwork
    padding: 2 * $r 2 * $r

.modal-body 
    position: relative
    padding: 0
   

.btn-close 
    border: none
    padding: 2 * $r
    cursor: pointer
    font-weight: bold
    color: $color-text-main
    background: transparent


.btn-success 
    color: white
    background: $color-bg-main
    border: 1px solid $color-bg-main

@media only screen and (max-width: 640px) 
    .modal 
        min-width: 0
        

</style>
